export default {
  setOrgTypes(state, data) {
    state.orgTypes = data;
  },
  setOrgData(state, data) {
    state.orgData = data;
  },
  setMyOrgList(state, data) {
    state.myOrgList = data;
  },
  addMyOrg(state, org) {
    if (!state.myOrgList) state.myOrgList = [];
    const exists = state.myOrgList.some(o => o.id === org.id);
    if (!exists) {
      state.myOrgList.unshift(org);
    }
  },
  setOtherOrgList(state, data) {
    state.otherOrgList = data;
  },
  setSearchMembers(state, data) {
    state.serchMembers = data;
  },
  setNoSearchMembers(state, query) {
    state.noSearchMembers = query;
  },
  setCurrentProfileOrg(state, data) {
    state.currentOrgProfile = data;
  },
  setNoSearchOrgs(state, query) {
    state.noSearchOrgs = query;
  },
  setNumFollowersChannel(state, data) {
    state.numFollowersChannel = data;
  },
  setOrgPosts(state, posts) {
    state.orgPosts = posts;
  },
  appendOrgPosts(state, posts) {
    state.orgPosts = [...state.orgPosts, ...posts];
  },
  async setCollectionOrg(state, { collectionName, data, isReply }) {
    if (Array.isArray(state[collectionName])) {
      if (collectionName === 'orgPosts') {
        state[collectionName] = [...state[collectionName], ...data];
      } else {
        state[collectionName] = [...data];
      }
    }
  },
  addOrgPost(state, post) {
    if (!state.orgPosts) {
      state.orgPosts = [];
    }
    
    // If this is a reply, try to integrate it with the parent post
    if (post.type === 'reply' && post.repostedPostId) {
      const parentPost = state.orgPosts.find(p => p.id === post.repostedPostId);
      if (parentPost) {
        // Initialize integrated replies if not already present
        if (!parentPost.integratedReplies) {
          parentPost.integratedReplies = [];
          parentPost.hasIntegratedReplies = true;
          parentPost.totalRepliesCount = 0;
        }
        
        // Add the new reply to the parent's integrated replies
        parentPost.integratedReplies.unshift(post);
        parentPost.totalRepliesCount = parentPost.integratedReplies.length;
        
        // Don't add the reply as a standalone post
        return;
      }
    }
    
    // For non-replies or replies without a parent, add as standalone post
    state.orgPosts.unshift(post);
  },
  setStatusLoad(state, status) {
    state.isLoading = status;
  },
  setJoinRequests(state, requests) {
    state.joinRequests = requests;
  },
  clearJoinRequests(state) {
    state.joinRequests = [];
  },
  setBannedUsers(state, data) {
    state.bannedUsersList = data;
  },
  addFollowingChannel(state, channel) {
    if (!state.followingChannels) {
      state.followingChannels = [];
    }
    state.followingChannels.push(channel);
  },
  removeFollowingChannel(state, channelId) {
    if (!state.followingChannels) return;
    state.followingChannels = state.followingChannels.filter(
      (c) => c.channelId !== channelId
    );
  },
  setFollowingChannels(state, channels) {
    state.followingChannels = channels;
  },
};
